import {
  APIServiceError,
  UnknownAPIServiceResponseError,
} from 'frontcore/data/api-service/service-error/errors/service-error'
import { APIServiceResponse } from 'frontcore/data/api-service/types'
import { InvalidFileContentError } from 'frontcore/data/api-service/service-error/errors/file-errors'
import { MissingParameterError } from 'frontcore/data/api-service/service-error/errors/api-errors'
import {
  PasswordExpiredError,
  PasswordResetLinkAlreadyUsedServiceError,
  PasswordResetLinkExpiredServiceError,
  PasswordResetLinkInvalidServiceError,
  TokenExpiredServiceError,
} from 'frontcore/data/api-service/service-error/errors/authorization-errors'
import { SendToGMAORemoteServiceError } from 'frontcore/data/api-service/service-error/errors/action-errors'
import { UnansweredCriteriaError } from 'frontcore/data/api-service/service-error/errors/audit-errors'
import { UnknownFileTypeError } from 'frontcore/data/api-service/service-error/errors/core-errors'

export enum ServiceCode {
  // Unknown error
  UNKNOWN_ERROR = 0,

  // Audit errors
  UNANSWERED_CRITERIA = 10001,

  // API errors
  MISSING_PARAMETER = 20001,

  // File errors
  INVALID_FILE_CONTENT = 30001,

  // Action errors
  SEND_TO_GMAO_REMOTE_SERVICE = 40001,

  // Authentication errors
  PASSWORD_EXPIRED = 90001,
  TOKEN_EXPIRED = 90002,
  PASSWORD_RESET_LINK_EXPIRED = 90004,
  PASSWORD_RESET_LINK_INVALID = 90005,
  PASSWORD_RESET_LINK_ALREADY_USED = 90006,

  // Core errors
  INVALID_FILE_EXTENSION = 91002,
}

export const ServiceCodeErrorMap: { [K in ServiceCode]: new (response: APIServiceResponse) => APIServiceError } = {
  [ServiceCode.UNKNOWN_ERROR]: UnknownAPIServiceResponseError,
  [ServiceCode.UNANSWERED_CRITERIA]: UnansweredCriteriaError,
  [ServiceCode.MISSING_PARAMETER]: MissingParameterError,
  [ServiceCode.SEND_TO_GMAO_REMOTE_SERVICE]: SendToGMAORemoteServiceError,
  [ServiceCode.PASSWORD_EXPIRED]: PasswordExpiredError,
  [ServiceCode.PASSWORD_RESET_LINK_EXPIRED]: PasswordResetLinkExpiredServiceError,
  [ServiceCode.PASSWORD_RESET_LINK_INVALID]: PasswordResetLinkInvalidServiceError,
  [ServiceCode.PASSWORD_RESET_LINK_ALREADY_USED]: PasswordResetLinkAlreadyUsedServiceError,
  [ServiceCode.TOKEN_EXPIRED]: TokenExpiredServiceError,
  [ServiceCode.INVALID_FILE_EXTENSION]: UnknownFileTypeError,
  [ServiceCode.INVALID_FILE_CONTENT]: InvalidFileContentError,
}
